<ul class="timeline">
    <li class="timeline-event">
      <label class="timeline-event-icon"></label>
      <div class="timeline-event-copy">
        <p class="timeline-event-thumbnail">1843 - 1843</p>
        <h3>Cuentos nuevos</h3>
        <h4>Copenhague-Dinamarca</h4>
        <p><strong>El patito feo</strong><br>El traje nuevo del emperador</p>
      </div>
    </li>
    <li class="timeline-event">
      <label class="timeline-event-icon"></label>
      <div class="timeline-event-copy">
        <p class="timeline-event-thumbnail">1819 - 1819</p>
        <h3>La novia de Lammermoor</h3>
        <h4>Bruden fra Lammermoor</h4>
        <p>Original, romántica ballad opera en cuatro actos</p>
      </div>
    </li>
    <li class="timeline-event">
      <label class="timeline-event-icon"></label>
      <div class="timeline-event-copy">
        <p class="timeline-event-thumbnail">1827 - 1827</p>
        <h3>El niño moribundo</h3>
        <h4>Escuela Helsingør</h4>
        <p><strong>Kjøbenhavns flyvende Post</strong><br>Versiones danesa y alemana de la revista</p>
      </div>
    </li>
  </ul> 
  
<!--The template for this timeline was done by https://codepen.io/Fischaela Thank you Fischaela-->